import { Injectable } from '@angular/core';
import { EntityStateStore } from '@shared/store/entity-state-store';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

/** Navigatie-items van een app worden bij het opslaan gesorteerd (sortDescendants). */
@Injectable({ providedIn: 'root' })
export class EgiAppEntityStore extends EntityStateStore<EgiAppEntity> {
  constructor() {
    super();
  }

  set(entities: readonly EgiAppEntity[]): void {
    entities.forEach(app => app.rootNavigationItem.sortDescendants());
    super.set(entities);
  }

  add(entityOrEntities: EgiAppEntity | readonly EgiAppEntity[]): void {
    const apps = Array.isArray(entityOrEntities) ? entityOrEntities : [entityOrEntities as EgiAppEntity];
    apps.forEach(app => app.rootNavigationItem.sortDescendants());
    super.add(entityOrEntities);
  }
}
